import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexColCenterHorizontal } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { ButtonWithRequest } from './ButtonWithRequest';

interface Props {
  price: string;
  unit: string;
  addToRequest: any;
  addToCart: any;
  noStock?: boolean;
  isInCart?: boolean;
}

function ProductPriceCartMobile({
  price,
  unit,
  addToCart,
  addToRequest,
  noStock,
  isInCart,
}: Props) {
  return (
    <Wrapper>
      <ButtonWithRequest
        onButtonClick={addToCart}
        onRequestClick={addToRequest}
        noStock={noStock}
        isInCart={isInCart}
      />
      <Price>{price ? `${price} € / ${unit}` : ''}</Price>
    </Wrapper>
  );
}

const Wrapper = styled(FlexColCenterHorizontal)`
  justify-content: space-between;
  align-items: flex-end;
`;

const Price = styled.span`
  margin-top: ${rem(26)};
  font-family: ${({ theme }) => theme.font.tertiary};
  font-size: ${rem(12)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  white-space: nowrap;
`;

export { ProductPriceCartMobile };
